import React from 'react';
import { LocationPage } from './useLocationPage';
import './useLocationPage.css';

// ─── Images ───────────────────────────────────────────────────────────────────
// Swap out any of these for Sarasota-specific shots
import heroImg   from '../images/tampa3.webp';
import bgImg     from '../images/image8.webp';
import slideImg1 from '../images/image121.webp';
import slideImg2 from '../images/image117.webp';
import slideImg3 from '../images/image50.webp';

// ─── Config ───────────────────────────────────────────────────────────────────
const sulphurSpringsConfig = {

  /* ── SEO ────────────────────────────────────────────────────────────────── */
  pageTitle:       'Sulphur Springs Tree Service | Sam\'s Tree Service',
  metaDescription: 'Professional tree trimming and removal in Sulphur Springs, FL. Sam\'s Tree Service handles dangerous trees safely and affordably.',
  canonicalUrl:    'https://samstreeservice.com/tree_service_sulphur_springs',

  /* ── Hero ───────────────────────────────────────────────────────────────── */
  heroHeading: 'Serving Sulphur Springs',
  heroImageUrl: heroImg,
  bgImageUrl:   bgImg,

  /* ── Slide images ───────────────────────────────────────────────────────── */
  slideImage1: slideImg1,
  slideImage2: slideImg2,
  slideImage3: slideImg3,

  /* ── Main text panel ────────────────────────────────────────────────────── */
  sectionHeading: 'Professional Tree Service in Sulphur Springs Specializing In Dangerous Trees',

  paragraphs: [
    `At <strong>Sam's Tree Service</strong>, we provide dependable tree care to 
     the residential neighborhoods of <strong>Sulphur Springs</strong>. This 
     North Tampa community along the Hillsborough River has established streets 
     lined with mature trees that have grown large and close to homes, fences, 
     and utility lines over the decades. Florida's storm season puts those trees 
     to the test every year and our team handles the hazards they create 
     quickly and professionally.`,

    `We specialize in <strong>hazardous tree removal and precision trimming in 
     established urban neighborhoods</strong> large overhanging limbs near 
     homes and parked vehicles, storm split trunks, trees with root damage 
     near aging foundations, and tight lot removals that require careful 
     planning and execution. We assess every job on site and do it right.`,

    `<strong>Sam's Tree Service</strong> delivers trusted, affordable tree care 
     throughout <strong>Sulphur Springs</strong> and the surrounding 
     <strong>North Tampa</strong> riverfront communities keeping your 
     property safe and your trees well-managed through every season.`,
  ],
  ctaLabel: 'Get a Free Estimate!',

  /* ── Service buttons (optional — defaults to the 4 standard ones) ────────── */
  // serviceButtons: [
  //   { label: 'Tree Trimming', to: '/tree_trimming' },
  //   { label: 'Tree Removal',  to: '/tree_removal'  },
  //   { label: 'Stump Removal', to: '/stump_removal'  },
  //   { label: 'Debris Hauling',to: '/debris_hauling' },
  // ],

  /* ── Google Map ─────────────────────────────────────────────────────────── */
  mapCity: 'Sulphur Springs, FL',
};

// ─── Page ─────────────────────────────────────────────────────────────────────
const Services_SulphurSprings = () => <LocationPage config={sulphurSpringsConfig} />;
export default Services_SulphurSprings;
